import { c as _c } from "react/compiler-runtime";
export const PatientSidebarSectionSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mt-2"><div className="h-4 w-24 animate-pulse rounded bg-muted" /><div className="mt-2 h-20 animate-pulse rounded-md bg-muted" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};